const BASE_URL = "https://mailxto.hahu.one/api/";

export const REGISTER_URL = BASE_URL + "register";
export const LOGIN_URL = BASE_URL + "login";

export const NEW_LINK_URL = BASE_URL + "create-link";
export const LINKS_URL = BASE_URL + "my-links";
export const UPDATE_LINKS_URL = BASE_URL + "update-link";
